import styled from 'styled-components'
import { variant } from 'styled-system'

import Text from './Text'

const defaultValues = {
  fontSize: ['16px'],
  fontFamily: 'Proxima',
  letterSpacing: '0.352px',
  lineHeight: '24px',
  fontWeight: '400',
  textTransform: 'uppercase'
}

const Caption = styled(Text)(
  variant({
    variants: {
      bold: {
        fontWeight: 'bold'
      },
      heavy: {
        fontWeight: 'heavy'
      },
      medium: {
        fontWeight: '400'
      }
    }
  })
)

Caption.defaultProps = {
  as: 'h4',
  variant: 'bold',
  ...defaultValues
}

export { Caption, defaultValues }
